import PropTypes from 'prop-types'
import {
  Table, Button, Select,
  Input,
} from 'antd'
import history from 'utils/history'

const TemankuDownlinePage = ({
  dataTemanku, statusClaim, statusIuran, statusRegistration,
  handleChangeStatusClaim, handleChangeStatusIuran, handleChangeStatusRegistration,
  handleSearch, handlePage,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: '',
      key: 'No',
      width: 100,
      render: (text, record, index) => (dataTemanku.meta.per_page * (dataTemanku.meta.current_page - 1)) + index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 180,
      render: text => text || '-',
    },
    {
      title: 'No Peserta',
      dataIndex: 'registered_number',
      key: 'registered_number',
      width: 120,
      render: text => text || '-',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 240,
      render: text => text || '-',
    },
    {
      title: 'No Telepon',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 150,
      render: text => text || '-',
    },
    {
      title: 'Status Registration',
      dataIndex: 'registration_status',
      key: 'registration_status',
      width: 160,
      render: text => (<span className="text-capitalize ml-3">{text || '-'}</span>),
    },
    {
      title: 'Status Iuran',
      dataIndex: 'deposit_status',
      key: 'deposit_status',
      width: 140,
      render: text => (<span className="text-capitalize">{text || '-'}</span>),
    },
    {
      title: 'Status Klaim',
      dataIndex: 'claim_status',
      key: 'claim_status',
      width: 140,
      render: text => (<span className="text-capitalize">{text || '-'}</span>),
    },
    {
      title: 'Komisi',
      dataIndex: 'point_commission',
      key: 'point_commission',
      width: 200,
      render: text => (
        <span>
          {text || '0'}
          {' '}
          Poin
        </span>
      ),
    },
  ]
  return (
    <div className="pb-3">
      <div className="btn-primary-wrapper mb-5">
        <Button type="primary" icon="arrow-left" onClick={() => history.goBack()}>Go Back</Button>
      </div>
      <div className="pb-3">
        <div className="d-flex justify-content-start btn-primary-wrapper">
          <div>
            <Input.Search
              placeholder="Search"
              style={{ width: 260 }}
              className="mr-3"
              onSearch={handleSearch}
              allowClear
              enterButton
            />
          </div>
          <div className="d-flex align-items-center mr-2">
            <h6 className="mb-0 mr-2" style={{ fontSize: '14px' }}>Status Klaim :</h6>
            <Select
              placeholder="Status Klaim"
              defaultValue=""
              style={{ width: 180 }}
              onChange={handleChangeStatusClaim}
              allowClear
            >
              {statusClaim.map(item => <Select.Option key={item.id} value={item.value}>{item.label}</Select.Option>)}
            </Select>
          </div>
          <div className="d-flex align-items-center mr-2">
            <h6 className="mb-0 mr-2" style={{ fontSize: '14px' }}>Status Iuran :</h6>
            <Select
              placeholder="Status Iuran"
              defaultValue=""
              style={{ width: 180 }}
              onChange={handleChangeStatusIuran}
              allowClear
            >
              {statusIuran.map(item => <Select.Option key={item.id} value={item.value}>{item.label}</Select.Option>)}
            </Select>
          </div>
          <div className="d-flex align-items-center mr-2">
            <h6 className="mb-0 mr-2" style={{ fontSize: '14px' }}>Status Registrasi :</h6>
            <Select
              placeholder="Status Registrasi"
              defaultValue=""
              style={{ width: 180 }}
              onChange={handleChangeStatusRegistration}
              allowClear
            >
              {statusRegistration.map(item => <Select.Option key={item.id} value={item.value}>{item.label}</Select.Option>)}
            </Select>
          </div>
        </div>
      </div>
      <Table
        rowKey="member_id"
        className="table-striped-rows"
        columns={columns}
        dataSource={dataTemanku.data}
        loading={dataTemanku.isFetching}
        scroll={{ x: 1200 }}
        pagination={{
          showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
          pageSize: dataTemanku.meta ? dataTemanku.meta.per_page : 10,
          total: dataTemanku.meta ? dataTemanku.meta.total_count : dataTemanku.data.length,
          current: dataTemanku.meta ? dataTemanku.meta.current_page : 1,
          onChange: handlePage,
        }}
      />
    </div>
  )
}

TemankuDownlinePage.propTypes = {
  dataTemanku: PropTypes.object,
  statusClaim: PropTypes.array,
  statusIuran: PropTypes.array,
  statusRegistration: PropTypes.array,
  handleChangeStatusClaim: PropTypes.func,
  handleChangeStatusIuran: PropTypes.func,
  handleChangeStatusRegistration: PropTypes.func,
  handleSearch: PropTypes.func,
  handlePage: PropTypes.func,
}

export default TemankuDownlinePage
